<script setup>
  import { tagStyle } from "./serving-size-calculator.js";

  defineProps({
    categories: { type: Array, required: true },
    clickableGroups: { type: Boolean, default: false },
  });

  const emit = defineEmits(["select", "see", "group-click"]);
</script>

<template>
  <ul v-for="cat in categories" :key="cat.name" class="results">
    <li>
      <div class="is-flex-grow-1">
        <div>{{ cat.name }}</div>
        <div
          v-if="cat.group"
          class="tag mt-1"
          :class="{ 'is-clickable': clickableGroups }"
          :style="tagStyle(cat.group)"
          @click.stop="clickableGroups && emit('group-click', cat.group)"
        >
          {{ cat.group }}
        </div>
      </div>
      <button
        v-if="!cat.see"
        class="button is-primary is-align-self-center"
        @click="emit('select', cat)"
      >
        Select
      </button>
      <button v-else class="button is-info is-align-self-center" @click="emit('see', cat.see)">
        See: {{ cat.see }}
      </button>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
  @import "~/jose_modern/css";

  .results {
    li {
      background-color: $white-bis;
      border-radius: 0.5em;
      padding: 1em;
      margin-bottom: 0.5em;
      display: flex;
      gap: 1em;

      &:hover {
        background-color: $grey-lighter;
      }
    }
  }
</style>
